<template>
  <button
    v-if="clickable"
    class="list-row-container"
    @click="$emit('row-clicked')"
  >
    <slot />
  </button>
  <div
    v-else
    class="list-row-container"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    rowClicked() {
      this.onClick();
      this.$emit('row-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.list-row-container {
  align-items: center;
  background-color: #ffffff;
  border-bottom: solid 1px #dfe3e9;
  box-sizing: border-box;
  color: $grey-2;
  display: flex;
  font-size: rem-calc(12);
  font-weight: $semi-bold;
  height: rem-calc(58);
  padding: rem-calc(0) rem-calc(16);
  text-align: left;
  text-decoration: none;

  &:hover {
    background-color: #F1F4F8;
  }

  &:nth-child(2n + 2):not(.list-heading) {
    background-color: rgba(241, 244, 248, 0.48);

    &:hover {
      background-color: #F1F4F8;
    }
  }

  &:last-child {
    border: none;
    border-radius: 0 0 4px 4px;
  }

  .row-group {
    align-items: center;
    display: flex;
    flex: 1;

    @include breakpoint(small) {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }

  /deep/ img.arrow {
    margin: auto 0 auto rem-calc(24);
    width: rem-calc(14);
  }

  /deep/ .center-container {
    align-items: center;
    display: flex;
    flex: 1;

    @include breakpoint(small) {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }

  /deep/ .name {
    align-items: center;
    display: flex;
    flex: 1;
    font-size: rem-calc(12);
    margin-left: rem-calc(16);

    @include breakpoint(small) {
      margin-left: 0;
    }
  }

  &.list-heading {
    color: $grey-3;
    font-size: rem-calc(12);

    .name-heading {
      flex: 1;
      margin-left: rem-calc(16);
    }
  }
}
</style>
